import { Injectable } from '@angular/core';
import { QiraEventHumanReadable } from '@app/services/event-tracker.service';
import { environment } from '@env';
import * as Sentry from '@sentry/angular';
import { GoogleTagManagerConfiguration, GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagService {
  dataLayer?: any[];

  gtmService?: GoogleTagManagerService;

  async init() {
    try {
      const configuration = new GoogleTagManagerConfiguration();
      this.gtmService = new GoogleTagManagerService(configuration, environment.GTM_ID, 'silent', '', '', '', 'CSP-NONCE');
      await this.gtmService.addGtmToDom();
      this.dataLayer = this.gtmService.getDataLayer();
    } catch (e) {
      console.error('[GoogleTagService] Error when adding GTM to dom', e);
      Sentry.captureException(e, {
        level: 'error',
        tags: {
          location: 'GoogleTagService',
          feature: 'GoogleTagManager',
          message: 'Error when adding GTM to dom.',
        },
        extra: {
          message: '[GoogleTagService] Error when adding GTM to dom.',
        },
      });
    }
  }

  gtmIsEnabled() {
    return environment.GTM_ID && environment.GTM_ID.length > 0;
  }

  public push(qiraEvent: QiraEventHumanReadable, params?: any) {
    if (!environment.enableEventTracking) return;
    // Convert numeric enum to string name - GTM requires event to be a string
    const eventName = QiraEventHumanReadable[qiraEvent] || String(qiraEvent);
    try {
      this.dataLayer?.push({ ...params, event: eventName });
      console.log('[GoogleTagService] pushed event', eventName, 'with params', params);
    } catch (e: any) {
      console.error('[GoogleTagService] Error when pushing event', eventName, 'with params', params, ':', e);
      Sentry.captureException(e, {
        level: 'info',
        tags: {
          location: 'GoogleTagService',
          feature: 'GoogleTagManager',
          message: 'Error when pushing event to GTM.',
        },
        extra: {
          qiraEvent,
          eventName,
          params,
          message: '[GoogleTagService] Error when pushing event to GTM.',
        },
      });
    }
  }
}
